// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2pm4f","title":"Info_title__1V3mQ","selects":"Info_selects__2e3aT","requiredAsterisk":"Info_requiredAsterisk__oXyWB"};